import React from "react";
import moment from "moment";
import { Modal, Input, Form, Select, Icon, Tag, DatePicker, Tabs, Button } from "antd";
import {
	FORMAT_NUMBER,
	FORMAT_3DECIMALS,
	GREATER_THAN_ZERO
} from "../../../common/types/regularExpresionType";
import { message } from 'antd';
import global from "../../../common/utility/global";
import TextArea from "antd/lib/input/TextArea";

import { REGISTRADO } from '../../../common/types/fondoFijoEstadoType';

const InputGroup = Input.Group;
const { Option } = Select;
const { Search } = Input;

class FormModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	handleCompleteDecimals = (property, value) => {
		if (value === "" || isNaN(parseFloat(value).toFixed(3)))
			this.props.form.setFieldsValue({ [property]: "0.000" });
		else
			this.props.form.setFieldsValue({
				[property]: parseFloat(value).toFixed(3),
			});
	};

	findDaysAndDates = (property, value) => {
		if (property === "diasVencimiento") {
			const fecha = moment(
				this.props.form.getFieldValue("fechaStr"),
				"DD/MM/YYYY"
			);
			const diasVencimiento = parseInt(value);
			this.props.form.setFieldsValue({
				fechaVencimientoStr: fecha.add("days", diasVencimiento),
			});
		}

		if (property === "fechaVencimientoStr") {
			const fecha = moment(
				this.props.form.getFieldValue("fechaStr"),
				"DD/MM/YYYY"
			);
			const fechaVencimiento = moment(value, "DD/MM/YYYY");
			this.props.form.setFieldsValue({
				diasVencimiento: fechaVencimiento.diff(fecha, "days").toString(),
			});
		}

		if (property === 'fechaStr') {
			const fechaVencimiento = moment(this.props.form.getFieldValue('fechaVencimientoStr'), 'DD/MM/YYYY');
			const fecha = moment(value, 'DD/MM/YYYY');
			const mf = fecha.format('YYYY/MM/DD');
			console.log('cambio 2');

			this.props.form.setFieldsValue({ diasVencimiento: fechaVencimiento.diff(fecha, 'days').toString(), minFechaStr: mf });
		}
	};

	handleCancel = () => {
		this.props.onClose();
		this.props.form.resetFields();
	};

	handleOk = (e) => {
		
		e.preventDefault();
		this.props.form.validateFieldsAndScroll((err, values) => {
			console.log(values);
			if (!err) {
				const form = {
					"id": values.id,
					"idEstablecimiento": values.idEstablecimiento.key,
					"idEmpleado": values.idEmpleado.key,
					"idCentroCosto": values.idCentroCosto.key,
					"idFondoFijoEstado": REGISTRADO,
					"fechaStr": values.fechaStr.format('DD/MM/YYYY'),
					"serie": values.serie,
					"documento": values.documento,
					"saldoInicialSoles": parseFloat(values.saldoInicialSoles),
					"saldoCierreSoles": parseFloat(values.saldoInicialSoles),
					"saldoInicialDolares": parseFloat(values.saldoInicialDolares),
					"saldoCierreDolares": parseFloat(values.saldoInicialDolares),
					"tipoCambio": parseFloat(values.tipoCambio),
					"diasVencimiento": parseInt(values.diasVencimiento),
					"fechaVencimientoStr": values.fechaVencimientoStr.format('DD/MM/YYYY'),
					"observacion": values.observacion,
					"fondoFijoDetalles": [],
				}

				if (!(values.saldoInicialSoles > 0 || values.saldoInicialDolares > 0)) {
					message.warning('Por favor ingrese un monto en soles o dolares.');
					return;
				}

				// var count_detalles = values.arrDetalle.length;
				// for (var i = 0; i < count_detalles; i++) {
				// 	var det = values.arrDetalle[i];

				// 	const itemDet = {
				// 		"id": 0,
				// 		"idFondoFijo": null,
				// 		"idMoneda": parseInt(det.idMoneda),
				// 		"idPlanCuenta": parseInt(det.idPlanCuenta),
				// 		"idFondoFijoDetalleEstado": parseInt(det.idFondoFijoDetalleEstado),
				// 		"registroContable": det.registroContable,
				// 		"monto": det.monto,
				// 		"fechaEntrega": det.fechaEntrega,
				// 		"Descripcion": det.Descripcion
				// 	}

				// 	form.fondoFijoDetalles.push(itemDet);
				// }

				this.props.onSave(form, this.props.form);

			}
		});
	}

	handleSearchAutocompleteEmpleado = async (value) => {
		const result = this.props.formValues.empleados.filter(item => {
			return global.formatSearch(`${item.nombre} - ${item.tipoDocumento}`).match(global.formatSearch(value));
		}).slice(0, 75);
		this.props.form.setFieldsValue({ empleados: result });
	};

	handleChangeAutocompleteEmpleado = async (a, element) => {
		this.props.form.setFieldsValue({
			documentoEmpleado: element.props.data.numeroDocumento,
			idEmpleado: element.props.data.idEmpleado
		}, () => {
			this.props.onChange("idEmpleado", element.props.data.idEntidad, this.props.form)
		});
	};

	render() {
		const { getFieldDecorator, setFieldsValue, getFieldValue } =
			this.props.form;

		getFieldDecorator("id", { initialValue: this.props.formValues.id });

		getFieldDecorator("empleados", {
			initialValue: this.props.formValues.empleados.filter((m) => {
				return m.id === this.props.formValues.idEmpleado;
			}),
		});

		return (
			<Modal
				title={(<div> {this.props.formValues.id === 0 ? `Registrar Fondo Fijo` : `Modificar Fondo Fijo`}</div>)}
				visible={this.props.visible}
				style={{ top: 30 }}
				cancelText={"Cancelar"}
				okText={"Guardar"}
				onCancel={(properties) => {
					if (
						!properties.target.className.toString().match("ant-modal-wrap") ||
						properties.type === "keydown"
					)
						this.handleCancel();
				}}
				onOk={this.handleOk}
				width="1100px"
			>
				<Form>
					{getFieldDecorator("id", { initialValue: this.props.formValues.id })(
						<input type="hidden" />
					)}

					{getFieldDecorator('minFechaStr', { initialValue: this.props.formValues.minFechaStr })(
						<input type="hidden" />
					)}

					<div className="row">
						<div className="col-md-4 form-group">
							<Form.Item label="Serie / Documento">
								<InputGroup compact>
									<Form.Item style={{ width: "40%" }}>
										{getFieldDecorator("serie", {
											initialValue: this.props.formValues.serie,
										})(
											<Input
												placeholder="Serie"
												autoComplete="off"
												className="first-input"
												disabled={true}
											/>
										)}
									</Form.Item>
									<Form.Item style={{ width: "60%" }}>
										{getFieldDecorator("documento", {
											initialValue: this.props.formValues.documento,
										})(
											<Input
												placeholder="Documento"
												autoComplete="off"
												className="second-input"
												disabled={true}
											/>
										)}
									</Form.Item>
								</InputGroup>
							</Form.Item>
						</div>
						<div className="col-md-4 form-group">
							<Form.Item label="Fecha / Tipo de Cambio">
								<InputGroup compact>
									<Form.Item style={{ width: "65%" }}>
										{getFieldDecorator("fechaStr", {
											initialValue: moment(
												this.props.formValues.fechaStr,
												"DD/MM/YYYY"
											),
											rules: [
												{
													type: "object",
													required: true,
													message: "Requerido",
												},
											],
										})(
											<DatePicker
												className="first-input"
												placeholder="Seleccione fecha"
												prefix={
													<Icon
														type="filter"
														style={{ color: "rgba(0,0,0,.25)" }}
													/>
												}
												format="DD/MM/YYYY"
												onChange={(moment, value) => {
													this.props.onChange(
														"fechaStr",
														value,
														this.props.form
													);
													this.findDaysAndDates("fechaStr", value);
												}}
											/>
										)}
									</Form.Item>
									<Form.Item style={{ width: "35%" }}>
										{getFieldDecorator("tipoCambio", {
											initialValue: parseFloat(
												this.props.formValues.tipoCambio
											).toFixed(3),
											rules: [
												{
													required: true,
													pattern: new RegExp(FORMAT_3DECIMALS),
													message: "Formato decimal incorrecto (0.000)",
												},
											],
										})(
											<Input
												className="text-right second-input"
												placeholder="Ingresar Tipo de Cambio"
												autoComplete="off"
												onBlur={(e) =>
													this.handleCompleteDecimals(
														"tipoCambio",
														e.target.value
													)
												}
											/>
										)}
									</Form.Item>
								</InputGroup>
							</Form.Item>
						</div>

						<div className="col-md-4 form-group">
							<Form.Item label="Días / Fecha de Vencimiento">
								<InputGroup compact>
									<Form.Item style={{ width: "35%" }}>
										{getFieldDecorator("diasVencimiento", {
											initialValue: this.props.formValues.diasVencimiento,
											rules: [
												{
													required: true,
													pattern: new RegExp(FORMAT_NUMBER),
													message: "Formato incorrecto",
												},
											],
										})(
											<Input
												style={{ textAlign: "right" }}
												placeholder="Ingresar días de vencimiento"
												autoComplete="off"
												className="first-input"
												onBlur={(e) =>
													this.findDaysAndDates(
														"diasVencimiento",
														e.target.value
													)
												}
											/>
										)}
									</Form.Item>
									<Form.Item style={{ width: "65%" }}>
										{getFieldDecorator("fechaVencimientoStr", {
											initialValue: moment(
												this.props.formValues.fechaVencimientoStr,
												"DD/MM/YYYY"
											),
											rules: [
												{
													type: "object",
													required: true,
													message: "Requerido",
												},
											],
										})(
											<DatePicker
												placeholder="Seleccione fecha"
												prefix={
													<Icon
														type="filter"
														style={{ color: "rgba(0,0,0,.25)" }}
													/>
												}
												format="DD/MM/YYYY"
												className="second-input"
												onChange={(moment, value) =>
													this.findDaysAndDates("fechaVencimientoStr", value)
												}
												disabledDate={d => !d || d.isBefore(this.props.form.getFieldValue('minFechaStr'))}
											/>
										)}
									</Form.Item>
								</InputGroup>
							</Form.Item>
						</div>
					</div>

					<div className="row">
						<div className="col-md-4 form-group">
							<Form.Item label="Establecimiento">
								{getFieldDecorator("idEstablecimiento", {
									initialValue: this.props.formValues.idEstablecimiento
										? { key: this.props.formValues.idEstablecimiento }
										: undefined,
									rules: [
										{
											required: true,
											message: "Campo obligatorio.",
										},
									],
								})(
									<Select
										showSearch labelInValue
										placeholder={"Seleccione Establecimiento"}
										optionFilterProp="children"
										onChange={(option) => {
											this.props.form.setFieldsValue({ idCentroCosto: undefined });
											this.props.onChange("idEstablecimiento", option.key);
										}}
									>
										{this.props.formValues.establecimientos.map((item) => (
											<Option key={item.id} value={item.id}>{item.nombre}</Option>
										))}
									</Select>
								)}
							</Form.Item>
						</div>
						<div className="col-md-4 form-group">
							<Form.Item label="Centro de Costo">
								{getFieldDecorator("idCentroCosto", {
									initialValue: this.props.formValues.idCentroCosto
										? { key: this.props.formValues.idCentroCosto }
										: undefined,
									rules: [
										{
											required: true,
											message: "Campo obligatorio.",
										},
									],
								})(
									<Select
										showSearch labelInValue
										placeholder={"Seleccione Centro de Costo"}
										optionFilterProp="children"
										loading={this.props.formValues.centroCostoLoading}
									>
										{this.props.formValues.centrosCosto.map((item) => (
											<Option key={item.id} value={item.id}>{item.nombre}</Option>
										))}
									</Select>
								)}
							</Form.Item>
						</div>
						<div className="col-md-4 form-group">
							<Form.Item label="Saldo Inicial Soles">
								{getFieldDecorator("saldoInicialSoles", {
									initialValue: parseFloat(
										this.props.formValues.saldoInicialSoles
									).toFixed(2),
								})(
									<Input
										className="text-right"
										placeholder="Ingresar saldo inicial soles"
										autoComplete="off"
										onKeyPress={global.onKeyPressDecimals}
									/>
								)}
							</Form.Item>
						</div>
					</div>


					<div className="row">
						<div className="col-md-8 form-group">
							<Form.Item label="Responsable">
								<InputGroup compact>
									<Form.Item style={{ width: "30%" }}>
										{getFieldDecorator("documentoEmpleado", {
											initialValue: this.props.formValues.documentoEmpleado,
											rules: [
												{
													required: true,
													message: "Campo obligatorio.",
													whitespace: true,
												},
											],
										})(
											<Search
												placeholder="DNI/CE/Pasaporte"
												className="first-input"
												autoComplete="off"
												loading={this.props.formValues.empleadoLoading}
												onSearch={(value) =>
													this.props.onBuscarEmpleado(value, this.props.form)
												}
												maxLength={20}
											/>
										)}
									</Form.Item>
									<Form.Item style={{ width: "70%" }}>
										{getFieldDecorator("idEmpleado", {
											initialValue: this.props.formValues.idEmpleado
												? { key: this.props.formValues.idEmpleado }
												: undefined,
											rules: [
												{
													required: true,
													message: "Campo obligatorio.",
												},
											],
										})(
											<Select
												showSearch
												labelInValue
												style={{
													width: `calc(100% - 40px)`,
													borderTopLeftRadius: "0px",
												}}
												placeholder={"Seleccione Responsable"}
												optionFilterProp="children"
												showArrow={false}
												onSearch={this.handleSearchAutocompleteEmpleado}
												onChange={this.handleChangeAutocompleteEmpleado}
											>
												{getFieldValue("empleados").map((item) => (
													<Option key={item.id} value={item.id} data={item}>
														<Tag>{item.tipoDocumentoNombre}</Tag>
														{`${item.nombre}`}
													</Option>
												))}
											</Select>
										)}
									</Form.Item>
								</InputGroup>
							</Form.Item>
						</div>
						<div className="col-md-4 form-group">
							<Form.Item label="Saldo Inicial Dólares">
								{getFieldDecorator("saldoInicialDolares", {
									initialValue: parseFloat(
										this.props.formValues.saldoInicialDolares
									).toFixed(2),
								})(
									<Input
										className="text-right"
										placeholder="Ingresar saldo inicial dólares"
										autoComplete="off"
										onKeyPress={global.onKeyPressDecimals}
									/>
								)}
							</Form.Item>
						</div>
					</div>

					<div className="row">
						<div className="col-md-12 form-group">
							<Form.Item label="Observación">
								{getFieldDecorator("observacion", {
									initialValue: this.props.formValues.observacion,
								})(
									<TextArea
										placeholder="Ingresar Observación"
										autoComplete="off"
									/>
								)}
							</Form.Item>
						</div>
					</div>
				</Form>
			</Modal>
		);
	}
}

export default Form.create()(FormModal);
